import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { View } from 'react-native';

import { logoutSucceeded } from '../../../common/components/Auth/authSlice';

import { EmptyState, PrimaryButton } from '../../design/components';
import { useThemedStyles } from '../../hooks/useThemedStyles';

const AuthExpired = () => {
	const dispatch = useDispatch();
	const styles = useThemedStyles(createStyles);

	const handeOnClick = useCallback(() => {
		dispatch(logoutSucceeded());
		// Navigation will be handled automatically by AppNavigation
		// based on the Redux auth state change
	}, [dispatch]);

	return (
		<View style={styles.container}>
			<View style={styles.content}>
				<EmptyState
					icon="clock"
					title="Your session has expired. Please log in again."
				/>
				<PrimaryButton onPress={handeOnClick} label="Back to log in" />
			</View>
		</View>
	);
};

const createStyles = ({ ui: { colors, layout, space } }) => ({
	container: {
		flex: 1,
		justifyContent: 'center',
		paddingHorizontal: space.xl,
		backgroundColor: colors.canvas,
	},
	content: {
		width: '100%',
		maxWidth: layout.maxContentWidth,
		alignSelf: 'center',
	},
});

export default AuthExpired;
